import { createContext, useContext, useState } from "react";

const AddPostContext = createContext<any>(null);

export function AddPostProvider({ children }: { children: React.ReactNode }) {
  const [open, setOpen] = useState(false);

  return (
    <AddPostContext.Provider value={{ open, setOpen }}>
      {children}
    </AddPostContext.Provider>
  );
}

export function useAddPost() {
  return useContext(AddPostContext);
}
